import { FileEdit, Clock, CheckCircle, XCircle, Users } from 'lucide-react';

const today = new Date().toISOString().split('T')[0];

export const EMPTY_FORM = {
  contract_number: '', supplier_code: '', supplier_name: '', description: '',
  contract_value: 0, currency: 'USD', contract_manager: '',
  contract_start: today, contract_end: '',
  review_date: '', notice_period: 90, active: true,
  governing_law: '', payment_terms: 'Net 30', term_length: '12 months', liability_cap: '100% of fees',
  approval_route: [],
};

export const STATUS_CONFIG = {
  DRAFT:            { label: 'Draft',            cls: 'bg-gray-100 text-gray-700 border-gray-200',     Icon: FileEdit },
  UNDER_REVIEW:     { label: 'Under Review',     cls: 'bg-amber-100 text-amber-700 border-amber-200',   Icon: Clock },
  IN_VENDOR_REVIEW: { label: 'In CP Review', cls: 'bg-purple-100 text-purple-700 border-purple-200', Icon: Users },
  REVIEWING_VENDOR: { label: "Reviewing CP Comments", cls: 'bg-indigo-100 text-indigo-700 border-indigo-200', Icon: FileEdit },
  CP_REVIEW_COMPLETE: { label: "CP Review Complete", cls: 'bg-teal-100 text-teal-700 border-teal-200', Icon: CheckCircle },
  SENT_FOR_EXECUTION: { label: "Sent to CP — DocuSign", cls: 'bg-orange-100 text-orange-700 border-orange-200', Icon: Clock },
  EXECUTED_BY_CP: { label: "CP Signed — Awaiting Ours", cls: 'bg-lime-100 text-lime-700 border-lime-200', Icon: CheckCircle },
  APPROVED:         { label: 'Approved',         cls: 'bg-green-100 text-green-700 border-green-200',   Icon: CheckCircle },
  EXECUTED:         { label: 'Fully Executed',   cls: 'bg-green-100 text-green-700 border-green-200',   Icon: CheckCircle },
  REJECTED:         { label: 'Rejected',         cls: 'bg-red-100 text-red-700 border-red-200',         Icon: XCircle },
};

export const WorkflowBadge = ({ status, reviewStage, stageLabel }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.DRAFT;
  let displayLabel;
  if (status === 'APPROVED' && reviewStage === 'EXECUTED') {
    // All approval stages complete but not yet signed — show "Fully Approved"
    displayLabel = 'Fully Approved';
  } else if (['SENT_FOR_EXECUTION', 'EXECUTED_BY_CP', 'EXECUTED'].includes(status)) {
    // Signature-related statuses — use the status config label directly
    displayLabel = cfg.label;
  } else if (status === 'UNDER_REVIEW' && stageLabel) {
    displayLabel = `In ${stageLabel}`;
  } else if (status === 'DRAFT' && stageLabel && reviewStage && reviewStage !== 'DRAFT') {
    displayLabel = `Awaiting ${stageLabel}`;
  } else if (stageLabel && status !== 'DRAFT') {
    displayLabel = `${stageLabel} — ${cfg.label}`;
  } else {
    displayLabel = cfg.label;
  }
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${cfg.cls}`}>
      <cfg.Icon className="h-3 w-3" />{displayLabel}
    </span>
  );
};

export const CAT_COLOR = {
  'Services':            'bg-blue-50 border-blue-200 text-blue-700',
  'Goods':               'bg-green-50 border-green-200 text-green-700',
  'Confidentiality':     'bg-purple-50 border-purple-200 text-purple-700',
  'Compliance':          'bg-orange-50 border-orange-200 text-orange-700',
  'Commercial':          'bg-indigo-50 border-indigo-200 text-indigo-700',
  'Technology':          'bg-cyan-50 border-cyan-200 text-cyan-700',
  'Performance':         'bg-yellow-50 border-yellow-200 text-yellow-700',
  'Contract Management': 'bg-red-50 border-red-200 text-red-700',
};

export const GOVERNING_LAW = [
  'England & Wales', 'Scotland', 'New York', 'California', 'Delaware', 'Texas',
  'Federal Republic of Germany', 'France', 'Singapore', 'Hong Kong', 'Australia',
];

export const PAYMENT_TERMS = [
  'Net 15', 'Net 30', 'Net 45', 'Net 60', 'Net 90',
  'Due on Receipt', '2/10 Net 30', 'End of Month',
];
